import { entries } from "@/src/utils/object-funtions/entries";

/**
 * Error codes for known errors. Add more as needed.
 * */
export const ErrorCode = {
  EffectFailure: 1,
  ServerComponentRender: 2,
  InvariantViolation: 3,
  ValidationError: 4,
  JWTError: 5,
  UnknownError: 99,
} as const;

type ErrorCodeType = (typeof ErrorCode)[keyof typeof ErrorCode];

export interface OptionalError {
  message: string;
  name?: string;
}

export type ErrorWithCode = OptionalError & {
  code?: ErrorCodeType;
};

/**
 * Known error names that can be used to identify specific errors.
 * */
export const knownErrorNamesToCode = {
  "Invariant Violation": ErrorCode.InvariantViolation,
  CombinedGraphQLErrors: ErrorCode.UnknownError,
} satisfies Record<string, ErrorCodeType>;

/**
 * Known parts of error messages that can be used to identify specific errors.
 * */
export const knownErrorMessagePatternsToCode = {
  "Validation error": ErrorCode.ValidationError,
  "Effect failure": ErrorCode.EffectFailure,
  "An error occurred in the Server Components render":
    ErrorCode.ServerComponentRender,
  "Cannot decode JWT": ErrorCode.JWTError,
} satisfies Record<string, ErrorCodeType>;

export const getErrorMessageWithCode = (
  error: OptionalError,
  message: string,
): ErrorWithCode => {
  const defaultError = {
    message,
    code: ErrorCode.UnknownError,
  };

  for (const [msg, code] of entries(knownErrorMessagePatternsToCode)) {
    if (error.message.toLowerCase().includes(msg.toLowerCase())) {
      return { ...defaultError, code };
    }
  }

  // Test for exact name matches last, as they are less specific because of e.g. umbrella type CombinedGraphQLErrors
  for (const [name, code] of entries(knownErrorNamesToCode)) {
    if (error.name === name) {
      return { ...defaultError, code };
    }
  }

  return error;
};
